<script>
import { h } from 'vue-demi'

/**
 * @type {import('vue').Component}
 * @template
 * ```html
 * <HKLLeftRight>
 *   <span>Left</span>
 *   <span>Right</span>
 * </HKLLeftRight>
 * ```
 * @template
 * ```html
 * <HKLLeftRight>
 *   <template v-slot:left>
 *      <span>Left 1</span>
 *      <span>Left 2</span>
 *   </template>
 * </HKLLeftRight>
 * ```
 * @template
 * ```html
 * <HKLLeftRight>
 *   <template v-slot:right>
 *      <span>Right 1</span>
 *      <span>Right 2</span>
 *   </template>
 * </HKLLeftRight>
 * ```
 */
export default {
  setup (_, { slots }) {
    const toArray = (value) => Array.isArray(value) ? value : [value]
    const getSlots = (type = 'default') => (typeof slots[type] === 'function' ? toArray(slots[type]()) : [])
      .filter((s) => s && !(s.tag === undefined && s.data === undefined && (typeof s.text === 'string' && s.text.trim().length === 0)))
    const genContainerSlot = (className) => (slots = []) => {
      const currentSlots = toArray(slots)
      const extraProps = { class: className }
      if (currentSlots.length === 1 && currentSlots[0].tag) {
        const node = currentSlots[0]
        const { staticClass = '' } = node.data || {}
        node.data = Object.assign({}, node.data, { staticClass: `${staticClass} ${className}` })
        return node
      }
      return h('div', extraProps, currentSlots)
    }
    const genLeftSlot = genContainerSlot('hkl-left-right_left')
    const genRightSlot = genContainerSlot('hkl-left-right_right')
    return () => {
      const defaultSlots = getSlots('default')
        .filter((_, index) => index <= 1)
      const leftSlots = getSlots('left')
      const rightSlots = getSlots('right')
      let children = defaultSlots
      switch (true) {
        case (!!leftSlots.length && !!rightSlots.length):
          children = [leftSlots, rightSlots]
          break
        case !!leftSlots.length:
          children = [leftSlots]
          break
        case !!rightSlots.length:
          children = [[], rightSlots]
          break
      }
      children = children
        .map((slots, index) => index === 0 ? genLeftSlot(slots) : genRightSlot(slots))
      return h('div', { class: 'hkl-left-right' }, children)
    }
  },
}
</script>
<style lang="scss" scoped>
.hkl-left-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}
</style>
